
import { h, Fragment } from 'preact'; /** @jsx h */

import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';



export const About = (props) => {
    
    return <Layout.Stacked>
        <Layout.Section weight="equal">
            <h1 className="secondfont mb-3 font-weight-bold">
                About
            </h1>
            <p>
                <b>PyQML.com</b> and <b>Quantum-Machine-Learning.com</b> have one goal: to help you
                learn quantum computing and quantum machine learning.
            </p>
            <p>
                The pages are the first part of a larger endeavor to create <b>The PyQML Media And Press Organization</b> - an independent
                media organization that focuses on teaching technology and science in a no-nonsense way.
            </p>
           

        </Layout.Section>
    </Layout.Stacked>
            
}
  
